import * as turf from '@turf/turf';
import mapboxgl from 'mapbox-gl';


const sources_ids = ['sourceCommoditiesEducationSup'];
const layers_ids = ['layerCommoditiesEducationSup_Points'];
var markers = [];
var marker_img = '<svg width="14" height="14" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M400 575C395.648 574.999 391.372 573.863 387.594 571.703L168.75 446.625C166.848 445.527 164.691 444.949 162.495 444.95C160.3 444.951 158.143 445.53 156.242 446.63C154.341 447.729 152.764 449.309 151.668 451.212C150.572 453.115 149.997 455.273 150 457.469V575C149.996 579.462 151.187 583.844 153.448 587.69C155.709 591.537 158.959 594.708 162.859 596.875L387.859 721.875C391.573 723.938 395.752 725.021 400 725.021C404.248 725.021 408.427 723.938 412.141 721.875L637.141 596.875C641.041 594.708 644.291 591.537 646.552 587.69C648.813 583.844 650.004 579.462 650 575V457.469C650.003 455.273 649.428 453.115 648.332 451.212C647.236 449.309 645.659 447.729 643.758 446.63C641.857 445.53 639.7 444.951 637.505 444.95C635.309 444.949 633.152 445.527 631.25 446.625L412.406 571.703C408.628 573.863 404.352 574.999 400 575Z" fill="white"/><path d="M774.875 297.656C774.875 297.656 774.875 297.531 774.875 297.484C774.47 293.522 773.125 289.713 770.951 286.375C768.776 283.038 765.836 280.268 762.375 278.297L412.375 78.297C408.596 76.1374 404.32 75.0015 399.968 75.0015C395.617 75.0015 391.34 76.1374 387.562 78.297L37.5621 278.297C33.7369 280.484 30.5576 283.643 28.3465 287.455C26.1353 291.266 24.9707 295.594 24.9707 300C24.9707 304.406 26.1353 308.734 28.3465 312.546C30.5576 316.357 33.7369 319.516 37.5621 321.703L387.562 521.703C391.34 523.863 395.617 524.999 399.968 524.999C404.32 524.999 408.596 523.863 412.375 521.703L720.312 345.75C720.788 345.475 721.328 345.331 721.878 345.331C722.427 345.332 722.967 345.477 723.442 345.753C723.918 346.029 724.312 346.425 724.586 346.902C724.859 347.379 725.002 347.919 725 348.469V574.297C725 587.75 735.343 599.297 748.796 599.969C752.177 600.132 755.555 599.607 758.726 598.425C761.897 597.244 764.796 595.431 767.246 593.097C769.696 590.762 771.646 587.954 772.979 584.844C774.312 581.733 774.999 578.384 775 575V300C774.998 299.217 774.956 298.435 774.875 297.656Z" fill="white"/></svg>';

export const get_ids = () => {
    // Get all source ids
    var sources = [];
    sources_ids.forEach(source_id => {
        sources.push({ id: source_id });
    })
    // Get all layer ids
    var layers = [];
    layers_ids.forEach(layer_id => {
        layers.push({ id: layer_id });
    })

    return {
        sources: sources,
        layers: layers,
        markers: markers,
    }
}


export const get_data = (capacity) => {
    // Set map data
    var map_data = {
        sources: [],
        layers: [],
        markers: [],
        bbox: null
    }

    // Check needed data
    if (!capacity?.context?.commodities?.education_university?.items || !capacity.context.commodities.education_university.items.length > 0) {
        return map_data
    }

    // Preset layer data
    var layer_data = {
        type: 'FeatureCollection',
        features: [],
    };

    // Add data
    for (var i = 0; i < capacity.context.commodities.education_university.items.length; i++) {
        var item = capacity.context.commodities.education_university.items[i];
        var item_marker_coords = null;
        // Generate polygon
        if (item?.type === "way" && item?.coords && item.coords.length > 3 && item.coords[0].length === 2 && item.coords[0][0] === item.coords[item.coords.length - 1][0] && item.coords[0][1] === item.coords[item.coords.length - 1][1]) {
            layer_data.features.push({
                type: "Feature",
                properties: item?.properties || null,
                geometry: {
                    type: "Polygon",
                    coordinates: [item.coords],
                }
            });
            try {
                var center = turf.centroid(turf.polygon([item.coords]));
                item_marker_coords = center?.geometry?.coordinates || null;
            } catch (error) {
                item_marker_coords = null;
            }
        }
        // Generate point
        else if (item?.type === "node" && item?.coords && item.coords.length === 2) {
            layer_data.features.push({
                type: "Feature",
                properties: item?.properties || null,
                geometry: {
                    type: "Point",
                    coordinates: item.coords,
                }
            });
            item_marker_coords = item.coords;
        }
        // Generate marker
        if (item_marker_coords !== null && item_marker_coords.length === 2) {
            var title = "Etablissement d'enseignement suppérieur";
            var title_txt = '<span style="color:#062134;font-size:15px;font-weight:700"><strong>' + title + '</strong></span>';
            var infos = [
                { label: "Nom", value: item?.properties?.name || "NC" },
                { label: "Opérateur", value: item?.properties?.operator || "NC"},
                { label: "Distance", value: item?.properties?.distance ? item?.properties?.distance + " m" : "NC"},
            ]
            var infos_txt = infos.map(info => { return ('<br /><span style="font-size:12px;font-weight: 600;color: grey;">' + info.label + ' :</span><br /><span style="color:#062134;font-weight:500;">' + info.value + '</span>') }).join('');
            var marker_label = item?.properties?.name || "Etablissement d'enseignement suppérieur";
            var el = document.createElement('div');
            el.className = 'marker';
            el.innerHTML = '<div style="cursor:pointer;padding:3px 8px 2px;background-color:#062134;border-radius:6px;display:flex;justify-content:center;align-items:center;gap:4px"><div style="display:flex;justify-content:center">' + marker_img + '</div><div style="font-family:Manrope;color:#FFF;">' + marker_label + '</div></div>';
            map_data.markers.push(new mapboxgl.Marker(el)
                .setLngLat(item_marker_coords)
                .setPopup(new mapboxgl.Popup({ offset: 15 })
                    .setHTML('<p style="font-family:Manrope">' + title_txt + infos_txt + '</p>'))
            )
        }
    }

    // Check data exists
    if (!layer_data.features.length > 0) {
        return map_data
    }

    // Create sources
    map_data.sources.push(
        {
            id: sources_ids[0],
            value: {
                type: 'geojson',
                data: layer_data
            }
        }
    )

    // Create layers
    map_data.layers.push(
        {
            id: layers_ids[0],
            type: 'fill',
            source: sources_ids[0],
            paint: {
                'fill-color': '#062134',
                'fill-opacity': 0.5,
            },
            filter: ['in', '$type', 'Polygon']
        }
    );

    // Set global markers
    if (map_data.markers.length > 0) {
        markers = map_data.markers;
    }
    else {
        markers = [];
    }

    // Get bbox
    var bbox_data = {
        type: 'FeatureCollection',
        features: layer_data.features.concat([capacity?.landBase?.union?.geometry]),
    };
    var bbox = turf.bbox(bbox_data);
    if (bbox && bbox.length === 4) {
        var bbox_poly = [
            [bbox[0], bbox[1]],
            [bbox[2], bbox[1]],
            [bbox[2], bbox[3]],
            [bbox[0], bbox[3]],
            [bbox[0], bbox[1]],
        ]
        map_data.bbox = [bbox_poly];
    }


    // Return
    // console.log("map_data", map_data);
    return map_data

}

